<template>
  <fts-design-modal
    width="992px"
    append-header-class="module-onboard-modal__header"
    append-content-class="module-onboard-modal__body"
    class="fts-module-onboard-modal"
    ref="ftsModuleOnboard"
    @closed="reset"
  >
  <!-- header -->
    <template #header>
      <fts-btn
        lg
        text
        icon
        @click="close"
      >
        <font-awesome-icon :icon="['fas', 'times']" />
      </fts-btn>
    </template>
    <!-- body -->
    <template #body>
      <!-- confetti -->
      <div class="confetti">
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
        <div class="confetti-piece"></div>
      </div>
      <!-- header -->
      <div class="design-modal-content__header">
        <div class="design-modal-content__header-title">
          Congratulations, that's it!
        </div>
        <div class="design-modal-content__header-description">
          You have created the module successfully. Start customizing or using on
          web browsers or mobile apps.
        </div>
      </div>
      <!-- illustration -->
      <div class="mo-illustration">
        <img src="../../assets/images/studio/congratulations.png" class="mo-illustration-img" />
      </div>
      <!-- select container -->
      <div class="mo-select-container">
        <div class="mo-select-wrapper">
          <div class="mo-select__header">
            <img src="../../assets/images/gif/tutorial-run.gif" class="mo-select__header-img">
          </div>
          <div class="mo-select-title">
            Run this app on browser
          </div>
          <div class="mo-select-description">
            Just click <b>Run</b> on the top right corner. 
            You can always do modification on module and click <b>Run</b>. Changes are instant
          </div>
        </div>

        <div class="mo-select-wrapper">
          <div class="mo-select__header mo-select-mobile-store">
            <a class="mo-select-mobile-store-img" :href="iOSAppStoreURL" target="_blank">
              <img src="../../assets/images/brand/app-store-black.svg" />
            </a>
            <a class="mo-select-mobile-store-img" :href="androindPlayStoreURL" target="_blank">
              <img src="../../assets/images/brand/google-play-badge.svg" />
            </a>
          </div>
          <div class="mo-select-title">
            Run this app on mobile or tablet 
          </div>
          <div class="mo-select-description">
            Download <b>Inistate</b> and login to start using
          </div>
        </div>

        <div class="mo-select-wrapper">
          <div class="mo-select__header">
            <font-awesome-icon :icon="['far', 'circle-question']" class="mo-select__header-icon" />
          </div>
          <div class="mo-select-title">
            Studio Tour
          </div>
          <div class="mo-select-description">
            Not sure how to enhance this app? Go through this 5 minutes tour with us and 
            unleash the power of Inistate
          </div>
          <div class="mo-select-action">
            <fts-btn
              text-transform-init
              box-shadow-none
              color="primary"
              @click="tour"
            >
              Begin Tour
            </fts-btn>
          </div>
        </div>
      </div>
      <!-- content:footer -->
      <div class="module-onboard-content__footer">
        <fts-btn text @click="close">
          Close
        </fts-btn>
      </div>
    </template> 
  </fts-design-modal>
</template>

<script>

import FTSDesignModal from "./FTSDesignModal";
import FTSBtn from "../elements/FTSBtn";
import commons from '../commons/commons';

export default {
  components: {
    "fts-design-modal": FTSDesignModal,
    "fts-btn": FTSBtn,
  },
  data: () => ({
    iOSAppStoreURL: commons.iOSAppStoreURL,
    androindPlayStoreURL: commons.androindPlayStoreURL,
    resolve: null,
  }),
  methods: {
    async show () {
      return new Promise(resolve => {
        this.resolve = resolve;
        this.$refs.ftsModuleOnboard.show();
      });
    },
    close() {
      this.$refs.ftsModuleOnboard.close();
    },
    reset() {
      Object.assign(this.$data, this.$options.data.apply(this));
    },
    tour() {
      this.resolve && this.resolve('tour');
      this.close();
    },
  },
}
</script>

<style lang="scss">
@import "./src/assets/scss/vars.scss";

.confetti {
  position: absolute;
  top: 0;
  right: 0;
  width: 100%;
  height: 100%;
  pointer-events: none;
}
.confetti-piece {
  position: absolute;
  top: 0;
  width: 10px;
  height: 30px;
  background-color: #ffd300;
  opacity: 0;
}
.confetti-piece:nth-child(1) {
  left: 7%;
  -webkit-transform: rotate(-40deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 182ms;
  -webkit-animation-duration: 1116ms;
}
.confetti-piece:nth-child(2) {
  left: 14%;
  -webkit-transform: rotate(4deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 161ms;
  -webkit-animation-duration: 1076ms;
}
.confetti-piece:nth-child(3) {
  left: 21%;
  -webkit-transform: rotate(-51deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 481ms;
  -webkit-animation-duration: 1103ms;
}
.confetti-piece:nth-child(4) {
  left: 28%;
  -webkit-transform: rotate(61deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 334ms;
  -webkit-animation-duration: 708ms;
}
.confetti-piece:nth-child(5) {
  left: 35%;
  -webkit-transform: rotate(-52deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 302ms;
  -webkit-animation-duration: 776ms;
}
.confetti-piece:nth-child(6) {
  left: 42%;
  -webkit-transform: rotate(38deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 180ms;
  -webkit-animation-duration: 1168ms;
}
.confetti-piece:nth-child(7) {
  left: 49%;
  -webkit-transform: rotate(11deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 395ms;
  -webkit-animation-duration: 1200ms;
}
.confetti-piece:nth-child(8) {
  left: 56%;
  -webkit-transform: rotate(49deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 14ms;
  -webkit-animation-duration: 887ms;
}
.confetti-piece:nth-child(9) {
  left: 63%;
  -webkit-transform: rotate(-72deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 149ms;
  -webkit-animation-duration: 805ms;
}
.confetti-piece:nth-child(10) {
  left: 70%;
  -webkit-transform: rotate(10deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 351ms;
  -webkit-animation-duration: 1059ms;
}
.confetti-piece:nth-child(11) {
  left: 77%;
  -webkit-transform: rotate(4deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 307ms;
  -webkit-animation-duration: 1132ms;
}
.confetti-piece:nth-child(12) {
  left: 84%;
  -webkit-transform: rotate(42deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 464ms;
  -webkit-animation-duration: 776ms;
}
.confetti-piece:nth-child(13) {
  left: 91%;
  -webkit-transform: rotate(-72deg);
  -webkit-animation: makeItRain 1000ms infinite ease-out;
  -webkit-animation-delay: 429ms;
  -webkit-animation-duration: 818ms;
}
.confetti-piece:nth-child(odd) {
  background-color: var(--fts-ternary-blue);
}
.confetti-piece:nth-child(even) {
  z-index: 1;
}
.confetti-piece:nth-child(4n) {
  width: 5px;
  height: 12px;
  -webkit-animation-duration: 2000ms;
}
.confetti-piece:nth-child(3n) {
  width: 3px;
  height: 10px;
  -webkit-animation-duration: 2500ms;
  -webkit-animation-delay: 1000ms;
}
.confetti-piece:nth-child(4n-7) {
  background: var(--fts-ternary-green);
}
@-webkit-keyframes makeItRain {
  from {opacity: 0;}
  50% {opacity: 1;}
  to {-webkit-transform: translateY(350px);}
}

.fts-module-onboard-modal {
  .module-onboard-modal__header {
    justify-content: flex-end;
    padding: 0.75rem;
  }
  .module-onboard-modal__body {
    position: relative;
    padding: 0 1.5rem 1.5rem;
  }
  .module-onboard-content__footer {
    margin-top: 1.5rem;
    text-align: right;
  }
  /* illustration */
  .mo-illustration {
    height: 20rem;
    margin-bottom: 2rem;
    text-align: center;
    .mo-illustration-img {
      max-width: 100%;
      max-height: 100%;
    }
  }
  /* select container */
  .mo-select-container {
    display: grid;
    gap: 1rem;
    border-radius: .5rem;
    background-color: var(--fts-primary-light);
    background-size: cover;
    background-image: url("../../assets/images/studio/mesh-gradient.png");
    .mo-select-wrapper {
      padding: 1.5rem;
      text-align: center;
    }
    .mo-select__header {
      @include flex-center-middle;
      height: 5rem;
      .mo-select__header-icon {
        font-size: 2.5rem;
        color: var(--fts-primary);
      }
      .mo-select__header-img {
        max-height: 100%;
        max-width: 100%;
        height: auto;
        width: auto;
      }
    }
    .mo-select-mobile-store {
      .mo-select-mobile-store-img {
        height: 2.5rem;
        display: inline-flex;
        &:not(:first-child) {
          margin-left: .5rem; 
        }
      }
    }
    .mo-select-title {
      margin-top: 1rem;
      font-weight: 700;
      font-size: 1.25rem;
      line-height: 1.75rem;
      color: var(--fts-primary);
    }
    .mo-select-description {
      margin-top: .5rem;
      font-size: 0.875rem;
      line-height: 1.25rem;
    }
    .mo-select-action {
      margin-top: 1rem;
    }
  }
  /* to-do utilities.scss */
  @media (min-width: 768px) {
    .mo-select-container {
      grid-template-columns: repeat(2,minmax(0,1fr));
    }
  }
  @media (min-width: 1024px) {
    .mo-select-container {
      grid-template-columns: repeat(3,minmax(0,1fr));
    }
  }
}
</style>